/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class Platform extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   * @param {Phaser.GameObjects.Container} group
   */
  constructor(scene, x, y, group) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, 'large_platform');

    this.setup(group);
  }

  setup (group) {
    this.scene.physics.add.existing(this);
    this.body.immovable = true;
    this.body.checkCollision.up = true;
    this.body.checkCollision.left = false;
    this.body.checkCollision.right = false;
    this.body.checkCollision.down = false;

    this.crumbles = false;
    this.moves = false;
    this.springs = false;
    this.jumpMod = 1.0;

    group.add(this);
    this.active = false;
    this.visible = false;
    this.body.enable = false;

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this));
  }

  spawn (x,y, vy = 0, ptype, pframename, crumble, moving, jumpMod) {
    if (ptype === void 0 || ptype === null) ptype = 1;
    if (jumpMod === void 0) jumpMod = 1.0;
    if (pframename === void 0 || pframename === null) {
      pframename = 1;
    }
    this.sizeId = pframename;
    this.crumbles = crumble;
    if (this.crumbles) {
      this.setFrame('crumble_platform');
    }
    else {
      this.setFrame(pframename);
    }
    this.moves = moving;
    this.jumpMod = jumpMod;

    this.body.setSize();
    this.setPosition(x + this.width / 2, y + this.height / 2);
    this.body.reset(this.x, this.y);
    this.active = true;
    this.visible = true;
    this.body.enable = true;
    this.body.setVelocity(0);
    this.body.velocity.y = vy;
    if (this.moves) {
      this.body.velocity.x = 200;
    }
    this.springs = false;
  }

  doCrumble () {
    this.active = false;
    this.visible = false;
    this.body.enable = false;
  }

  despawn () {
    this.active = false;
    this.visible = false;
    this.body.enable = false;
  }

  update () {
    if (this.moves) {
      if (this.body.x > 700) {
        this.body.velocity.x = -200;
      }
      else if (this.body.x <= 0) {
        this.body.velocity.x = 200;
      }
    }
  }
}